import React from 'react';
import UsefulLinksOne from './UsefulLinks';
import UsefulLinksTwo from './SupportLinks';
import Mousco from './Mousco';
import ContactUsFooter from './ContactUsFooter';
import './footerStyles/footerStyle.css';

function Footer() {
  return (
    <div className="Footer  bg-[#030A0E] pt-12 text-lg">
      <div className="wholeMiddleFooter lg:flex md:grid grid-cols-2 gap-x-20 bg-[#030A0E] px-12 w-full justify-between">
        <div className=''>
          < Mousco />
        </div>
        <div className=''>
          <UsefulLinksOne />
        </div>
        <div className=''>
          <UsefulLinksTwo />
        </div>
        <div className=''>
          <ContactUsFooter />
        </div>
      </div>
    </div>
  );
}

export default Footer;